import * as React from "react";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import WithSelection from "common/components/overlayTooltip/components/withSelection";
import { SimpleSelectItem } from "common/components/overlayTooltip/components/withSelection/rowItem";

interface IProps extends WrappedComponentProps {
  isLoading: boolean;
  labels: ReadonlyArray<Vingle.Interest.ILabel>;
  initialSelectedLabels: string[];
  onNewItemCreate: (value: string) => void;
  onSave: (changedLabel: Vingle.Interest.ILabelChange[]) => void;
  onCancel: () => void;
}

interface IState {
  selectedLabels: string[];
  changedLabel: Vingle.Interest.ILabelChange[];
}

class LabelTooltipContent extends React.PureComponent<IProps, IState> {
  public state: IState = {
    selectedLabels: this.props.initialSelectedLabels,
    changedLabel: [],
  };

  public componentDidUpdate(prevProps: IProps) {
    const { initialSelectedLabels, labels } = this.props;
    if (
      prevProps.labels !== labels ||
      prevProps.initialSelectedLabels !== initialSelectedLabels
    ) {
      this.setState({
        selectedLabels: initialSelectedLabels,
        changedLabel: [],
      });
    }
  }

  public render() {
    const { isLoading, onNewItemCreate, onCancel, intl } = this.props;
    return (
      <WithSelection
        isLoading={isLoading}
        headerText={<FormattedMessage id="desk.card.select_label" />}
        onClickNewItem={onNewItemCreate}
        onClickSave={this.handleSave}
        onClickCancel={onCancel}
        createInputPlaceholder={intl.formatMessage({ id: "add_to_new_label" })}
      >
        {this.renderLabels()}
      </WithSelection>
    );
  }

  private readonly renderLabels = () => {
    const { labels } = this.props;
    const selectedLabels = new Set(this.state.selectedLabels);
    return labels.map(label => {
      return (
        <SimpleSelectItem
          key={`labelSelectionTooltip_label_${label.id}`}
          text={label.name}
          checked={selectedLabels.has(label.id)}
          returnValue={label.id}
          onChange={this.handleCheckBoxChange}
        />
      );
    });
  };

  private readonly handleCheckBoxChange = (
    checkState: boolean,
    returnValue: any,
  ) => {
    const { changedLabel } = this.state;

    const filteredActions = changedLabel.filter(
      action => returnValue !== action.id,
    );
    this.setState({
      changedLabel: filteredActions.concat([
        {
          id: returnValue,
          action: checkState ? "add" : "remove",
        },
      ]),
    });
  };

  private readonly handleSave = () => {
    this.props.onSave(this.state.changedLabel);
  };
}

export default injectIntl(LabelTooltipContent);
